var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container text-center"},[_c('h1',{staticClass:"display-1 font-weight-light",staticStyle:{"color":"#007db6"}},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"mt-3 ne-body"},[_vm._v(_vm._s(_vm.subtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }